<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useMessageCenterStore } from '@/store';
import Sidebar from 'primevue/sidebar';

const messageCenter = useMessageCenterStore();
const { visible } = storeToRefs(messageCenter);

function closeSidebar() {
  messageCenter.visible = false;
  messageCenter.currentChatId = undefined;
}
</script>

<template>
  <Sidebar
    v-model:visible="visible"
    position="right"
    :modal="false"
    :dismissable="false"
    class="messages-sidebar m-2 border-round-lg shadow-lg"
    @hide="closeSidebar"
  >
    <template #header>
      <slot name="header"></slot>
    </template>

    <slot></slot>
  </Sidebar>
</template>

<style lang="scss">
.section-height {
  max-height: calc(100vh - 12.5rem);
}
.messages-sidebar {
  height: calc(100vh - 3.5rem);
  width: 400px;
  bottom: 0px;
  top: unset;
  z-index: 2;

  .icon-color {
    color: var(--gray-700);
  }
  .bg-my-gray {
    background-color: var(--surface-100);
  }
}
.messages-sidebar .p-sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0.5rem;
}
.messages-sidebar {
  ::-webkit-scrollbar {
    width: 5px;
  }
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  ::-webkit-scrollbar-thumb {
    background: #8888881a;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #88888885;
  }
}
.messages-sidebar .p-sidebar.p-sidebar-right {
  width: 365px;
}
.messages-sidebar .p-sidebar-content {
  height: 100%;
}
</style>
